import { Components, Theme } from '@mui/material/styles';
import { DEFAULT_BORDER_RADIUS } from '../constants';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: DEFAULT_BORDER_RADIUS,
      maxWidth: theme.spacing(600),
    }),
  },
};
